import React from 'react'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
const enterpriseapi = () => {
    return (
        <div>
            <Header />

            <section class="banner" style={{
                
                background:
                    "linear-gradient(135deg, var(--indigo) 0%, var(--indigo-d) 100%)",
                color: "#fff",
            }}>
                <div class="banner-blk ">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-md-6"><div class="content-blk">
                                <div class="hero-eyebrow"><span claclassnamess="hero-dot"></span>
                                    <span class="overline" style={{ color: "rgba(255,255,255,.65)" }}>Enterprise API · B2B SaaS · $5–$15 per query</span></div>
                                <h1 class="disp-xl">Compatibility intelligence
                                    for<em class="coral">every dating platform.</em></h1>
                                <p class="body-lg" style={{
                                    color: "rgba(255,255,255,.75)",
                                    marginTop: "20px",
                                    maxWidth: "520px",
                                }}>FutureSoulmates delivers as a white-label API plug-in to Match, Bumble, Shaadi.com, and fertility platforms. 90% B2B SaaS revenue. 80–90% gross margins. Launch-ready January 2027.</p>
                                <div class="hero-btns"><button class="btn btn-coral">How It Works <span class="arr">→</span></button>
                                    <button class="btn" style={{
                                        background: "rgba(255,255,255,.12)",
                                        color: "#fff", border: "1px solid rgba(255,255,255,.3)",
                                    }}>Get Your DNA Kit</button>
                                </div>
                            </div></div>
                             <div className="col-md-6">
                                <div class="hero-img-stack">
                                    <img alt="" src="/images/enterpriseapi-banner.jpg" />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="sec sec-white">
                <div className="sec-label">
                    <span
                        className="overline"
                        style={{ color: "var(--indigo)" }}
                    >
                        Business model
                    </span>
                </div>

                <h2 className="disp-md">
                    Infrastructure pricing.
                    <br />
                    Consumer-level value.
                </h2>

                <div
                    className="grid g3"
                    style={{ marginTop: "32px" }}
                >
                    <div
                        className="card"
                        style={{ borderTop: "3px solid var(--coral)" }}
                    >
                        <div className="card-tag tag-coral">Per-Query API</div>
                        <h3>$5–$15 / query</h3>
                        <p>
                            Per-compatibility query when a user requests a match or views a
                            compatibility score. Sliding scale based on volume tier.
                            Integrates in under a day via REST API.
                        </p>
                    </div>

                    <div
                        className="card"
                        style={{ borderTop: "3px solid var(--indigo)" }}
                    >
                        <div className="card-tag tag-indigo">DNA Bundle</div>
                        <h3>$580 / consumer kit</h3>
                        <p>
                            Full DNA saliva kit + lab processing + compatibility profile.
                            Offered as a premium upsell inside partner platforms. 60%
                            revenue share with platform partner.
                        </p>
                    </div>

                    <div
                        className="card"
                        style={{ borderTop: "3px solid var(--sage)" }}
                    >
                        <div className="card-tag tag-sage">Healthcare SaaS</div>
                        <h3>$200–$800 / case</h3>
                        <p>
                            Fertility clinic per-case fee for reproductive compatibility
                            scoring, HLA/KIR surrogate matching, and embryo viability
                            modelling. Integrates with major EMR systems.
                        </p>
                    </div>
                </div>

                <div
                    style={{
                        marginTop: "40px",
                        padding: "28px",
                        background: "var(--indigo-10)",
                        borderRadius: "var(--r16)",
                        border: "1px solid rgba(45,58,140,.15)",
                    }}
                >
                    <div
                        style={{
                            fontFamily: "var(--sans2)",
                            fontSize: "11px",
                            color: "var(--indigo)",
                            fontWeight: 700,
                            letterSpacing: ".1em",
                            textTransform: "uppercase",
                            marginBottom: "20px",
                        }}
                    >
                        REVENUE BREAKDOWN (YEAR 3 PROJECTION)
                    </div>

                    <div className="grid g3" style={{ gap: "16px" }}>
                        <div style={{ textAlign: "center" }}>
                            <div
                                style={{
                                    fontFamily: "var(--serif)",
                                    fontSize: "40px",
                                    fontWeight: 700,
                                    color: "var(--coral)",
                                }}
                            >
                                90%
                            </div>
                            <div style={{ fontSize: "13px", color: "var(--text-sec)" }}>
                                B2B API + SaaS licensing revenue
                            </div>
                        </div>

                        <div style={{ textAlign: "center" }}>
                            <div
                                style={{
                                    fontFamily: "var(--serif)",
                                    fontSize: "40px",
                                    fontWeight: 700,
                                    color: "var(--indigo)",
                                }}
                            >
                                82%
                            </div>
                            <div style={{ fontSize: "13px", color: "var(--text-sec)" }}>
                                Gross margins at scale
                            </div>
                        </div>

                        <div style={{ textAlign: "center" }}>
                            <div
                                style={{
                                    fontFamily: "var(--serif)",
                                    fontSize: "40px",
                                    fontWeight: 700,
                                    color: "var(--sage)",
                                }}
                            >
                                $140M
                            </div>
                            <div style={{ fontSize: "13px", color: "var(--text-sec)" }}>
                                Projected Year 3 revenue
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ marginTop: "28px" }}>
                    <div
                        style={{
                            fontFamily: "var(--sans2)",
                            fontSize: "11px",
                            color: "var(--text-mute)",
                            fontWeight: 700,
                            letterSpacing: ".1em",
                            textTransform: "uppercase",
                            marginBottom: "16px",
                        }}
                    >
                        TARGET PLATFORM PARTNERS
                    </div>

                    <div className="grid g4" style={{ gap: "12px" }}>
                        <div
                            className="card"
                            style={{ textAlign: "center", padding: "16px" }}
                        >
                            <div style={{ fontSize: "22px", marginBottom: "6px" }}>💕</div>
                            <div style={{ fontSize: "14px", fontWeight: 600 }}>
                                Match Group
                            </div>
                            <div style={{ fontSize: "12px", color: "var(--text-mute)" }}>
                                Match, Tinder, Hinge, OKCupid
                            </div>
                        </div>

                        <div
                            className="card"
                            style={{ textAlign: "center", padding: "16px" }}
                        >
                            <div style={{ fontSize: "22px", marginBottom: "6px" }}>🐝</div>
                            <div style={{ fontSize: "14px", fontWeight: 600 }}>
                                Bumble
                            </div>
                            <div style={{ fontSize: "12px", color: "var(--text-mute)" }}>
                                Bumble, Badoo
                            </div>
                        </div>

                        <div
                            className="card"
                            style={{ textAlign: "center", padding: "16px" }}
                        >
                            <div style={{ fontSize: "22px", marginBottom: "6px" }}>🌙</div>
                            <div style={{ fontSize: "14px", fontWeight: 600 }}>
                                Shaadi.com
                            </div>
                            <div style={{ fontSize: "12px", color: "var(--text-mute)" }}>
                                South Asian market
                            </div>
                        </div>

                        <div
                            className="card"
                            style={{ textAlign: "center", padding: "16px" }}
                        >
                            <div style={{ fontSize: "22px", marginBottom: "6px" }}>🏥</div>
                            <div style={{ fontSize: "14px", fontWeight: 600 }}>
                                Fertility Clinics
                            </div>
                            <div style={{ fontSize: "12px", color: "var(--text-mute)" }}>
                                IVF + donor + surrogate
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <section class="trusted-story">
                    <div class="container p-0">
                        <div class="cta-sec cta-coral">
                            <h2 class="disp-md">Your platform. Our intelligence. Better matches for your users.</h2>
                            <p>White-label API. Launch-ready Q1 2027. 30-day pilot available.</p>
                            <div class="cta-btns">
                                <button class="btn btn-white">Request API Demo <span class="arr">→</span></button>
                                <button class="btn investerbtn">Investor Overview</button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Footer />
        </div>
    )
}

export default enterpriseapi
